module.exports = __webpack_public_path__ + "static/media/comment-alt.70ce3f4d.svg";